import type { ModalStep } from 'Features/SellerCommunications/services';
import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import { ModalStepsToStageMap } from './consts';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { LOAD } = SNOWPLOW_EVENTS;

export const triggerSellerMessagingModalOpenedEvent = (step: ModalStep): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		customData: { label: `Stage: ${ModalStepsToStageMap[step]}` },
		name: 'dlr_seller_messaging_modal_opened',
		schemaName: LOAD.SCHEMA,
		version: LOAD.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
